<template>
  <div class="column content-box page_container full_page">
    <section>
        <div class="search-wrap filter_item">
          <fluent-icon icon="search" class="search-icon" />
           <input
            v-model="searchText"
            type="text"
            class="search_field font_normal"
            :placeholder="$t('ORDER.LIST_TABLE.SEARCH_PLACEHOLDER')"
            @keyup.enter="searchOrders"
          >
        </div>
        <div>
            <woot-button
                color-scheme="success"
                class-names="button--fixed-right-top add_order_item_btn"
                icon="add"
                @click="onCreateClick"
                >
                  {{$t('ORDER.CREATE_ORDER')}}
            </woot-button>
        </div>
    </section>

      <section class="filter_items header_filter">
        <div class="filter_item">
          <label class="font_regular text_12">{{$t('ORDER.LIST_TABLE.DATE.LABEL')}}</label>
          <date-range-picker
            :confirm-text="$t('ORDER.LIST_TABLE.DATE_SELECT_CONFIRM_BTN')"
            :placeholder="$t('ORDER.LIST_TABLE.DATE.PLACEHOLDER')"
            class="font_normal order_start_date"
            :value="dateRange"
            @change="handleDateChange"
            :disabledDate="disableFilterDate"
          />
        </div>

        <div class="filter_item">
          <label class="font_regular text_12">{{$t('ORDER.LIST_TABLE.STATUS.LABEL')}}</label>
          <multiselect
            v-model="selectedOrderStatuses"
            :options="OrderStatusList"
            class="small-12 font_normal order_multi_select"
            track-by="id"
            label="title"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :placeholder="$t('ORDER.LIST_TABLE.STATUS.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            @select="applyFilterByStatuses($event)"
            @remove="applyFilterRemoveStatus($event)"
          />
        </div>

        <div class="filter_item" style="max-width:100%;">
          <label class="font_regular text_12">{{$t('ORDER.LIST_TABLE.CUSTOM_COLUMN.LABEL')}}</label>
          <multiselect
            v-model="selectedCols"
            :options="cols"
            class="small-12 font_normal order_multi_select"
            style="width:auto;"
            track-by="key"
            label="name"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :placeholder="$t('ORDER.LIST_TABLE.CUSTOM_COLUMN.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            @select="applyFilterSelectedCol($event)"
            @remove="applyFilterSelectedCol($event)"
          />
          <!-- <woot-button
            class="margin-right-small clear"
            color-scheme="secondary"
            data-testid="create-new-contact"
            icon="filter"
            @click="onClickSelectColumn"
          >
            {{ $t('CONTACTS_PAGE.SELECT_COLUMNS') }}
          </woot-button> -->
        </div>
      </section>

      <section class="order_container">
        <order-table
          :orders="orders"
          :cols="cols"
          :isLoading="uiFlags.isFetching"
          :catalog="catalog"
          :onClickOrder="onClickOrder"
          :onSelectOrderStatus="onOrderStatusChange"
          @on-sort-change="onSortChange"
        />
        <div class="loadMore_btn">
          <woot-button
            variant="clear"
            size="small"
            color-scheme="primary"
            :is-loading="uiFlags.isFetching"
            :is-disabled="paginationCompute.isLastPage"
            @click="onPageChange(Number(meta.currentPage)+1)"
          >
            {{paginationCompute.btnText}}
          </woot-button>
        </div>
      </section>

      <woot-modal :show.sync="showSelectColumnModal" :on-close="onCloseSelectColumn">
        <SelectColumnModal
          :on-close="onCloseSelectColumn"
          :columns="cols"
          :handleColumnVisiblity="toggleColSelect"
        />
      </woot-modal>

    <SchedulePickUpModal
      :onClose="onPichupModalClose"
      :show="isPickupModalShow"
      :order="selectedOrderForSchedule"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DateRangePicker from "../../../../../dashboard/components/ui/DateRangePicker.vue"
import OrderTable from './OrderTable.vue';
import SelectColumnModal from './SelectColumnModal.vue';
import OrderAPI from "../../../../api/orders"
import alertMixin from 'shared/mixins/alertMixin';
import {ORDER_STATUSES} from "./order_constant"
import CatalogAPI from "../../../../api/catalogue/catalog";
// import OrderCard from "./OrderCard.vue";
import MerchantAPI from "../../../../api/merchant";
import SchedulePickUpModal from "./SchedulePickUpModal.vue";



export default {
  components: {
    DateRangePicker,
    OrderTable,
    SelectColumnModal,
    SchedulePickUpModal,
    // OrderCard,
  },
  mixins: [alertMixin],
  data() {
      const endDate = new Date(); // Current date
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 1); // One month ago
    return {
      searchText: '',
      selectedOrderStatuses: [],
      OrderStatusList: ORDER_STATUSES,
      dateRange: [startDate,endDate],
      cols: [
        { key: 'order_id', name: 'Order Id', visible: true, type: 'default' },
        { key: 'order_status', name: 'Order Status', visible: true, type: 'default' },
        { key: 'order_total', name: 'Order Total', visible: false, type: 'default' },
        { key: 'grand_total', name: 'Order Amount', visible: true, type: 'default' },
        { key: 'courier_fee', name: 'Courier fee', visible: true, type: 'default' },
        { key: 'courier_number', name: 'Courier number', visible: true, type: 'default' },
        { key: 'tracking', name: 'Tracking', visible: true, type: 'default' },
        { key: 'name', name: 'Name', visible: true, type: 'default' },
        { key: 'phone_number', name: 'Phone Number', visible: true, type: 'default' },
        { key: 'created_at', name: 'Created At', visible: true, type: 'default' },

        { key: 'paid_total', name: 'Paid Amount', visible: true, type: 'default' },
        { key: 'refund_amount', name: 'Refunded Amount', visible: true, type: 'default' },
        { key: 'line1', name: 'Line1', visible: true, type: 'default' },
        { key: 'line2', name: 'Line2', visible: false, type: 'default' },
        { key: 'city', name: 'City', visible: true, type: 'default' },
        { key: 'state', name: 'State', visible: false, type: 'default' },
        { key: 'postalCode', name: 'PostalCode', visible: false, type: 'default' },
        { key: 'country', name: 'Country', visible: false, type: 'default' },
      ],
      selectedCols:[],
      sortInfo:{},
      // selectedOrder: null,
      showSelectColumnModal: false,
      catalog: {},
      merchant: {},
      // selectedOrderStatusID: 'pending',
      selectedOrderForSchedule: null,
      isMerchantLoading:false,
      isPickupModalShow: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      uiFlags: "orders/getUIFlags",
      meta: "orders/getMeta",
      orders: "orders/getPaginatedOrders",
    }),
    paginationCompute(){
      const totalPages = Math.ceil(this.meta.count / this.meta.pageSize);
      const isLastPage = this.meta.currentPage >= totalPages;
      const currentCount = Math.min(this.meta.currentPage * this.meta.pageSize, this.meta.count);
      // const btnText = `Load More Orders (${currentCount}/${this.meta.count})`;
      const btnText = `${this.$t('ORDER.LIST_TABLE.LOAD_MORE_BTN')} (${currentCount}/${this.meta.count})`;

      return{
        isLastPage,
        btnText,
      }
    },



    // end of computed
  },
  mounted() {
    this.$store.dispatch("orders/getOrders",{
      start_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).start_date,
      end_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).end_date
    });
    this.getCatalog();
    this.getMerchant();
    // set initially selected colums
    this.setInitialTableCols();

    // check action cable if order is changed
    bus.$on('actionCableEvent_DeliveryEvent',(data)=>{
      // console.log("deliveryEvent on orderlist",data);
      this.handleActionCableDelivery(data);
    })

  },

  methods: {
    onPichupModalOpen(){
      this.isPickupModalShow = true;
    },
    onPichupModalClose(){
      this.isPickupModalShow = false;
      this.selectedOrderForSchedule = null;
    },
    onPageChange(page,option={}) {
      // console.log("ck",{statusFil:this.selectedOrderStatuses});

      this.$store.dispatch("orders/getPaginatedOrders",{
        currentPage:page,
        pageSize:this.meta.pageSize,
        searchText: this.searchText,
        sortBy: this.sortInfo.sortBy,
        sortOrder: this.sortInfo.sortOrder,
        statuesList: option.statuesList || this.selectedOrderStatuses.map(el=>el.id)
      })
    },
    onSortChange(params){
      const {order_id,...rest} = params;
      const newParams = {...rest,id:order_id}
      let newSort = {
        sortBy: 'id',  // default sort
        sortOrder: 'desc'
      }
      Object.keys(newParams).forEach(key=>{
        if (newParams[key]) {
          newSort.sortBy = key;
          newSort.sortOrder = newParams[key];
        }
      })
      this.sortInfo = newSort;
      this.onPageChange(1)
    },
    searchOrders() {
      this.onPageChange(1)
    },
    filterOrders() {

    },
    disableFilterDate(date,currentValues){
      const today = new Date();
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3); // 3 months ago

      if (date > today) {
        return true;
      }

      if (date < threeMonthsAgo) {
        return true;
      }
      return false;
    },
    formatStartEndDate(startDate,endDate){
      const providedStartDate = new Date(startDate);
      const providedEndDate = new Date(endDate);
      const option = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
      const formattedStartDate = providedStartDate.toLocaleDateString('fr-CA', option);
      const formattedEndDate = providedEndDate.toLocaleDateString('fr-CA', option);

      return {
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      };
    },
    applyFilterByStatuses(selectedOption){
      const statuesList = [...this.selectedOrderStatuses,selectedOption].map(el=>el.id);
      this.onPageChange(1,{statuesList})
    },
    applyFilterRemoveStatus(selectedOption){
      const statuesList = this.selectedOrderStatuses
      .filter(el=>el.id !== selectedOption.id)
      .map(el=>el.id);
      this.onPageChange(1,{statuesList})
    },
    async handleDateChange(dateRange) {
      this.dateRange = dateRange

      const date = this.formatStartEndDate(dateRange[0],dateRange[1]);

      await this.$store.dispatch("orders/getOrders",{
        start_date: date.start_date,
        end_date: date.end_date
      });

      this.onPageChange(1)
    },
    onClickOrder(order){
      // console.log({order,existOrder:this.selectedOrder});
     this.$router.push({name:"catalogue_order_details",params:{order_id:order.id}})

    },
    onClickSelectColumn(){
      this.showSelectColumnModal = true
    },
    onCloseSelectColumn(){
      this.showSelectColumnModal = false
    },
    toggleColSelect(col,index){
      // console.log({col,index});
    },
    async onOrderStatusChange(order,selectedStatus){
      console.log({order,selectedStatus});
      // open popup for specific condition
      if (selectedStatus.value === 'packed' && order.delivery !== 'self_collect') {
        console.log(order,selectedStatus,"PACK");
        // update on that index with the replaced object
        this.selectedOrderForSchedule = order;
        this.onPichupModalOpen();
        // this.$nextTick(() => {
        //   this.$forceUpdate();
        // });
        return
      }
      try {
        const payload = {order_status: selectedStatus.status_code}
        // const {data} = await OrderAPI.updateOrderById(order.id,payload);
        // dispatch update order
        await this.$store.dispatch("orders/UpdateOrderById",{order_id:order.id,payload});

        this.showAlert(this.$t('ORDER.LIST_TABLE.STATUS_UPDATE.SUCCESS_MSG'));
      } catch (error) {
        console.log(error);
        this.showAlert(this.$t('ORDER.LIST_TABLE.STATUS_UPDATE.FAIL_MSG'));
      }
    },
    async getCatalog(){
      try {
        const {data:catalog} = await CatalogAPI.getDefaultCatalog();
        this.catalog = catalog;
      } catch (error) {
        console.log(error);
      }
    },

    async getMerchant(){
      try {
        this.isMerchantLoading = true;
        const {data} = await MerchantAPI.getMerchantByName();
        this.merchant = data;
      } catch (error) {

      }
      this.isMerchantLoading = false
    },
    setInitialTableCols(){
      this.selectedCols = this.cols.filter(col=>col.visible);
    },
    async applyFilterSelectedCol(selectedOption){
      await  this.$nextTick();
      this.cols = this.cols.map(col=>{
        const isExist = this.selectedCols.find(el=>el.key === col.key);
        if (isExist) {
          return {...col,visible: true}
        }else{
          return {...col,visible: false}
        }
      })
    },
    handleActionCableDelivery(data){
      // if the event is from delvya
      // check if order is in this lislt or not
      const existOrder = this.orders.find(el=>el.id === data.order_id);
      if (existOrder && data.status_code === 100) {
        // this.showAlert(`Order id ${data.id} is created`);
        this.showAlert('Delivery was created successfully');
      }else if (existOrder && data.status_code && data.extras?.failedReason) {
        // this.showAlert(data.extras?.failedReason);
        this.showAlert('Delivery failed to be created');
      }

      const status = this.OrderStatusList.find(el=>el.id === data.order_status);
      if (status) {
        this.showAlert(`Order id ${data.id} is ${status.title}`);
      }
    },
    onCreateClick(){
      this.$router.push({
          name: 'catalogue_order_details',
          params: { accountId: this.currentUser.account_id, order_id:"new" }
        });
    },
    // end methods
  },
}
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';
@import '~dashboard/assets/scss/widgets/_fonts.scss';
@import '~dashboard/assets/scss/woot';

.page_container{
  min-height: calc(100vh - 120px);
}

.header_filter div:nth-child(1){
  // flex-grow: 1;
}
.loadMore_btn button{
  display: block;
  margin: auto;
}
.font_normal{
  font-size: 14px;
}

// order redesign
.statuses{
  display: flex;
  li{
    font-size: var(--font-size-small);
    // padding: var(--space-small);
    border-radius: var(--border-radius-normal);

    button{
      color: var(--s-600);
      font-weight: 500;
    }

    &:hover{
      background: var(--w-25);
      cursor: pointer;
      button{
        color: var(--w-500);
      }
      border-color: var(--w-25);
    }
  }
  .active{
    background: var(--w-25);
    button{
      color: var(--w-500);
    }
  }
}
/*
.orders{
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 1rem;
  list-style: none;
  @media screen and (max-width:768px) {
    grid-template-columns: repeat(1);
  }
  .text-right{
    text-align: right;
  }
}
*/
.filter_items{
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  @include breakpoint(xlarge up) {
    flex-wrap: nowrap;
  }
}
.filter_item{
  max-width: 280px;

  label{
    margin-bottom: 8px;
  }
}
.search-wrap{
  position: relative;

  .search_field{
    padding: 10px 12px 10px 40px;
    &::placeholder{
      color: #B8B8B8;
    }
  }

   .search-icon {
    position: absolute;
    top: 10px;
    left: 12px;
    // color: var(--b-700);
    color: #B8B8B8;
  }

}
.order_multi_select{
  width: 280px;
}
.order_container{
  margin-top: 10px;
}
</style>

<style>
.font_normal .multiselect__tags .multiselect__single, .font_normal input{
  font-size: 14px;
  font-weight: 500;
}
.order_multi_select{
  margin: 0;
}
.order_multi_select .multiselect__element{
  font-family: 'Figtree', sans-serif;
  line-height: 1.4;
  color: #1F1F1F;
  font-weight: 500;
}
.order_start_date{
  margin: 0;
}
.order_start_date .mx-datepicker{
  max-width: 280px;
}
</style>